import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Box, InputAdornment, TextField } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { createRules, FormFields } from '@epi-forms/helpers';
import {
  number,
  numberBetween,
  required as requiredValidation
} from '@epi-helpers/formHelpers/validators';
import { IContractPercentageField } from '@epi-models/pages/Beneficiaries';
import { EmployeeTypeModes } from '@epi-constants/beneficiary';

export const ContractPercentageField = ({
  disabled = false
}: IContractPercentageField) => {
  const { control, watch } = useFormContext();
  const { sizeMedium } = useTheme();
  const { t } = useTranslation();

  const betweenNumber = value => {
    const employeeType = watch(FormFields.EmployeeType);
    const isPartTime = employeeType === EmployeeTypeModes.PartTime;

    return isPartTime
      ? numberBetween(1, 99)(value)
      : numberBetween(1, 100)(value);
  };
  const rules = createRules([requiredValidation, betweenNumber, number]);
  const name = FormFields.EmployeePercentage;

  const {
    field: { onChange, value },
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });

  return (
    <TextField
      disabled={disabled}
      id={name}
      label={t('containers.beneficiaries.detail.working_hours_as_percentage')}
      value={value}
      onChange={onChange}
      readOnly={false}
      error={!!error}
      helperText={error?.message}
      required
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Box fontSize={sizeMedium}>%</Box>
          </InputAdornment>
        )
      }}
    />
  );
};
